import { FileUploadTemplate } from '@/components/FileUploadTemplate';
import { FC } from 'react';

export const Home: FC = () => {
  return (
    <FileUploadTemplate
      title="Validate source XLSX file"
      apiEndpoint="/validate"
      buttonText="Validate file"
      successMessage="Validation of the file was successful."
      validTitle="Validation"
    />
  );
};
